<template>
  <form @submit.prevent="saveConfig()" v-if="attentionConfig">
    <div class="mt-8 sm:mt-32">
      <h3>
        {{
          $t("labels.generic", {
            pt: "Configurações gerais",
            en: "General settings",
          })
        }}
      </h3>

      <div
        class="mt-4 bg-white w-[40%] min-w-[360px] min-h-[360px] shadow-md border-b-2 border-h-primary-500 rounded-md p-4"
      >
        <div class="flex flex-row justify-between">
          <h4>
            {{
              $t("labels.generic", {
                pt: "Monitoramento de atenção",
                en: "Attention monitoring",
              })
            }}
          </h4>
          <InputSwitch v-model="attentionConfig.attentionEnabled" />
        </div>

        <p class="mt-4">
          {{
            $t("labels.generic", {
              pt: "Ao ligar o monitoramento de atenção, nossa IA de reconhecimento facial irá checar se o aluno está atento ao vídeo.",
              en: "When turning attention monitoring on, our facial recognition AI will check if the student is attentive to the video.",
            })
          }}
        </p>
        <div class="flex flex-row justify-between items-center mt-8">
          <h6>
            {{
              $t("labels.generic", {
                pt: "Intervalo de detecção (segundos)",
                en: "Detection interval (seconds)",
              })
            }}
          </h6>
          <InputNumber
            v-model="attentionConfig.detectionInterval"
            inputId="minmax-buttons"
            mode="decimal"
            showButtons
            :min="0"
            class="w-[82px] h-[30px]"
            :disabled="!attentionConfig.attentionEnabled"
          />
        </div>
        <div class="flex flex-row justify-between items-center mt-8">
          <h6>
            {{
              $t("labels.generic", {
                pt: "Ângulo da cabeça (graus)",
                en: "Head angle (degrees)",
              })
            }}
          </h6>
          <InputNumber
            v-model="attentionConfig.headAngle"
            inputId="minmax-buttons"
            mode="decimal"
            showButtons
            :min="0"
            :max="90"
            class="w-[82px] h-[30px]"
            :disabled="!attentionConfig.attentionEnabled"
          />
        </div>
        <div class="flex flex-row justify-between items-center mt-8">
          <h6>
            {{
              $t("labels.generic", {
                pt: "Porcentagem de presença (%)",
                en: "Attendance percentage (%)",
              })
            }}
          </h6>
          <InputNumber
            v-model="attentionConfig.presencePercentage"
            inputId="minmax-buttons"
            mode="decimal"
            showButtons
            :min="0"
            :max="100"
            class="w-[82px] h-[30px]"
            :disabled="!attentionConfig.attentionEnabled"
          />
        </div>
        <div class="flex flex-row gap-4 items-center mt-8">
          <Checkbox
            v-model="attentionConfig.obligatoryPresence"
            :binary="true"
            :disabled="!attentionConfig.attentionEnabled"
          />
          <p>
            {{
              $t("labels.generic", {
                pt: "Presença obrigatória ativada",
                en: "Mandatory presence enabled",
              })
            }}
          </p>
        </div>
        <div class="flex flex-row justify-end gap-4 items-center mt-8">
          <Button class="btn-primary h-8"  type="submit" :loading="loading">
            {{
              $t("labels.generic", {
                pt: "Salvar",
                en: "Save",
              })
            }}
          </Button>
        </div>
      </div>
    </div>
  </form>
</template>

<script lang="ts">
import { AttentionRest } from "@/services/rest/attention.rest";
import { Messages } from "@/utils/messages.util";
import { ToastFactory } from "@/utils/toast-factory.util";
import { delay } from "rxjs";
import { defineComponent } from "vue";

export default defineComponent({
  name: "generalSettings",
  components: {},
  computed: {
    attentionRest(): AttentionRest {
      return new AttentionRest();
    },
  },
  data() {
    return {
      attentionConfig: {
        attentionEnabled: true,
        detectionInterval: 0,
        headAngle: 0,
        obligatoryPresence: true,
        presencePercentage: 0,
      },
      loading: false,
    };
  },
  mounted() {
    this.getConfig();
  },
  methods: {
    saveConfig(): void {
      this.loading = true;
      this.attentionRest
        .updateAttentionConfig(this.attentionConfig)
        .pipe(delay(300))
        .subscribe(() => {
          this.$toast.add(ToastFactory.success(Messages.EDIT_SUCCESS));
          this.loading = false;
        });
    },
    getConfig(): void {
      this.loading = true;
      this.attentionRest.getAttentionConfig().subscribe((res) => {
        this.attentionConfig = res.attentionConfig;
        this.loading = false;
      });
    },
  },
});
</script>
